const SmtpSettingsCloud = () =>
  <>
    You do not have permission to edit this content on cloud hosted DAI.
  </>

export default SmtpSettingsCloud
